import * as React from "react";
import {
  getInputPrimitiveClassName,
  inputPrimitiveVariants,
} from "@app/components/ui/input";

export interface TextareaPrimitiveProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: keyof typeof inputPrimitiveVariants;
}

export const TextareaPrimitive = React.forwardRef<
  HTMLTextAreaElement,
  TextareaPrimitiveProps
>(({ className, variant, ...props }, ref) => (
  <textarea
    className={getInputPrimitiveClassName(
      variant,
      "min-h-24 py-3 " + (className ?? ""),
    )}
    ref={ref}
    {...props}
  />
));

TextareaPrimitive.displayName = "TextareaPrimitive";
